import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'
import { required } from 'Utils/Validators/formValidation'

import Form from 'Components/Form'
import { Col, Row } from 'react-bootstrap'
import { Input } from 'Components/Form/Input'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { Textarea } from 'Components/Form/Textarea'
import SubmitButton from 'Components/Form/SubmitButton'
import Button from 'Components/Form/Button'
import Card from '@material-ui/core/Card'

import { DOCUMENT_FORM } from '../constants'

import { styles } from '../styles'

const DocumentForm = ({
  classes,
  submitHandler,
  mode,
  documentType,
  сountryCodeSelectOptions,
  redirectToDocumentationList,
}) => {
  return (
    <Form onSubmit={submitHandler}>
      <Card className={classes.card}>
        <Row className={classes.row}>
          <Col xs={12}>
            <p>
              Both the 'name' and 'instruction' information are shown in the
              app.
            </p>
          </Col>
        </Row>
        <Row className={classes.row}>
          <Col xs={mode === DOCUMENT_FORM.CREATE ? 6 : 4}>
            <Input
              label="Name"
              name="name"
              placeholder="Type of ID such as Drivers License or Passport"
              validator={[required]}
              initValue={documentType.name}
            />
          </Col>
          <Col xs={mode === DOCUMENT_FORM.CREATE ? 6 : 4}>
            <SelectDashboard
              name="countrycode"
              label="Country code"
              options={сountryCodeSelectOptions}
              initValue={
                Object.keys(documentType).length && documentType.countryCode
                  ? documentType.countryCode
                  : undefined
              }
              validator={[required]}
            />
          </Col>
          {mode === DOCUMENT_FORM.EDIT && (
            <Col xs={4}>
              <SelectDashboard
                name="active"
                label="Status"
                initValue={documentType.active.toString()}
                options={[
                  { label: 'Active', value: 'true' },
                  { label: 'Archived', value: 'false' },
                ]}
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col xs={12}>
            <Textarea
              name="instructiontext"
              label="Instruction"
              placeholder="Instructions required by a new BA when taking photos of this specific document"
              initValue={documentType.instructionText}
              validator={[required]}
            />
          </Col>
        </Row>
      </Card>
      <div className={classes.buttonsWrapper}>
        <Button
          variant="outlined"
          value="Cancel"
          onClick={redirectToDocumentationList}
        />
        <SubmitButton disabled={false} variant="contained" value="Submit" />
      </div>
    </Form>
  )
}

export default withStyles(styles)(DocumentForm)



// WEBPACK FOOTER //
// ./src/Containers/Settings/Documentation/DocumentForm/index.js